function getMismatchedOpenings(grp) {
  const openings = grp.items.order.filter((id) => {
    const item = grp.items[id];
    return item.is_collection;
  });

  const openingsObj = openings.reduce((acc, id) => {
    acc[id] = {
      opening: grp.items[id],
      items: [],
    };

    return acc;
  }, {});

  grp.items.order.forEach((id) => {
    const item = grp.items[id];
    if (item.collection_id && openingsObj[item.collection_id]) {
      openingsObj[item.collection_id].items.push(item);
    }
  });

  const containingOpenings = openings.filter(
    (id) => openingsObj[id].items.length > 0,
  );

  const mismatchedOpenings = containingOpenings.filter((id) => {
    const opening = openingsObj[id].opening;
    return openingsObj[id].items.some(
      (item) => item.quantity !== opening.quantity,
    );
  });
  return { openings, openingsObj, containingOpenings, mismatchedOpenings };
}

function checkOpeningItemQuantities(grp) {
  const { openings, openingsObj, containingOpenings, mismatchedOpenings } =
    getMismatchedOpenings(grp);

  let output = `
  Total openings: ${openings.length}
  Openings which contain items: ${containingOpenings.length}
  Openings with mismatched item quantities: ${mismatchedOpenings.length}

  Mismatched openings:`;
  mismatchedOpenings.forEach((id) => {
    const opening = openingsObj[id].opening;
    const items = openingsObj[id].items;
    output +=
      "\n  " +
      `  ${opening.mark}: ${opening.quantity} (${items.map((i) => i.quantity).join(", ")})`;
  });
  console.log(output);
}

function getOpeningItemUpdates(grp) {
  const { openingsObj, mismatchedOpenings } = getMismatchedOpenings(grp);
  return mismatchedOpenings.reduce((acc, id) => {
    const opening = openingsObj[id].opening;
    const updates = openingsObj[id].items
      .filter((item) => item.quantity !== opening.quantity)
      .map((item) => ({
        type: "item",
        id: item.id,
        prop: "quantity",
        value: opening.quantity,
      }));

    acc.push(...updates);
    return acc;
  }, []);
}

export { checkOpeningItemQuantities, getOpeningItemUpdates };
